// Pushes booking-funnel ecommerce events to the platform GTM container.
// Uses its own data layer (reserveportLayer) so the hotel's container never sees these events.
export function pushPlatformEvent (eventName, payload) {
  try {
    window.reserveportLayer = window.reserveportLayer || []
    window.reserveportLayer.push({ ecommerce: null })
    window.reserveportLayer.push({
      event: eventName,
      reserveport: {
        hotel_id: payload.hotel_id,
        hotel_name: payload.hotel_name,
        booking_engine_id: payload.hotel_id
      },
      ecommerce: {
        transaction_id: payload.transaction_id,
        currency: payload.currency,
        value: payload.value,
        items: payload.items
      }
    })
  } catch (error) {
    console.warn('platform analytics push failed', error)
  }
}

// Converts API amounts such as "20,000.00" to numbers.
export function toAmount (value) {
  return Number(String(value === undefined || value === null ? '' : value).replace(/,/g, '')) || 0
}

// Picks the value for the selected residency from a { res, nonres } object.
function forResidency (value, proofRes) {
  if (value && typeof value === 'object') {
    return Number(proofRes) === 1 ? value.nonres : value.res
  }
  return value
}

// Price for the selected residency.
export function residencyPrice (price, proofRes) {
  return toAmount(forResidency(price, proofRes))
}

// Currency shown on the site for the selected residency.
export function residencyCurrency (currency, proofRes) {
  return forResidency(currency, proofRes) || ''
}

// Lowest room price across a room's boards for the selected residency.
export function lowestPrice (boards, proofRes) {
  const prices = (boards || [])
    .map(board => residencyPrice(board.roomPrice, proofRes))
    .filter(price => price > 0)
  return prices.length ? Math.min(...prices) : 0
}

// Builds a GA4 item for a room.
export function roomItem (room, board, price, quantity) {
  return {
    item_id: String(room.id || room.name),
    item_name: room.name,
    item_category: 'Room',
    item_variant: board && board.name ? board.name : undefined,
    price: Number(price) || 0,
    quantity: quantity || 1
  }
}

// Merges identical rooms into one item each, counting how many were booked.
// rooms: [{ id?, name, meal_plan?, price }], one entry per room.
export function groupRoomItems (rooms) {
  const grouped = {}
  for (const room of rooms || []) {
    const price = toAmount(room.price)
    const key = [room.id || room.name, room.meal_plan || '', price].join('|')
    if (grouped[key]) {
      grouped[key].quantity++
    } else {
      grouped[key] = roomItem(room, { name: room.meal_plan }, price, 1)
    }
  }
  return Object.values(grouped)
}



// WEBPACK FOOTER //
// ./src/utils/ecommerce.js